import axios from 'axios';

export const searchForOrderToReturn = (zipCode, orderNo, setLoading) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const basePath = state.app.config.basePath;
  let response = {};
  setLoading(true);
  try {
    response = await axios.get(
      `${basePath}api/returns/orders/${orderNo}/${zipCode}`
    );
    setLoading(false);
  } catch (error) {
    setLoading(false);
    return error.response.data;
  }
  return response.data;
};

export const requestReturn = (orderId, orderToReturn, setLoading) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const basePath = state.app.config.basePath;
  let response = {};

  setLoading(true);

  try {
    response = await axios.post(
      `${basePath}api/returns/${orderId}`,
      orderToReturn
    );
    setLoading(false);
  } catch (error) {
    setLoading(false);
    return error.response.data;
  }
  return response;
};
